<template>
  <div class="deviceListWrapper dark-theme" style="background-color: #121212; min-height: 100vh; color: #ffffff">
    <div class="pa-4">
      <div class="mb-6 d-flex flex-row align-center">
        <v-text-field
          dark
          v-model="search"
          label="Suchen 1(Gerät oder Übung)"
          prepend-inner-icon="mdi-magnify"
          hide-details
          clearable
          outlined
          background-color="#1e1e1e"
          class="mr-4 text-h6"></v-text-field>
        <v-btn color="primary" height="56" class="white--text font-weight-bold text-h6 px-6" @click="openDeviceDialog(null)">
          <v-icon left>mdi-plus-thick</v-icon> NEU
        </v-btn>
      </div>

      <v-expansion-panels dark multiple v-model="activePanels" flat>
        <v-expansion-panel
          v-for="group in groupedCategories"
          :key="group.name"
          style="background-color: #1e1e1e; margin-bottom: 12px; border-radius: 8px">
          <v-expansion-panel-header class="text-h6 font-weight-bold text-uppercase white--text">
            {{ group.name }}
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12" sm="12" md="6" lg="4" v-for="device in group.devices" :key="device._id">
                <v-card
                  dark
                  color="#2a2a2a"
                  class="mb-3 elevation-4 rounded-lg d-flex flex-row overflow-hidden"
                  @click="openDeviceDialog(device)"
                  style="cursor: pointer; border: 1px solid #333">
                  <div style="width: 140px; min-width: 140px; background-color: #151515">
                    <v-img
                      :src="device.picture ? '/img/uebungen/' + device.picture : '/img/einmalig/imageUploadPlaceholder.jpg'"
                      height="120px"
                      width="140px"
                      cover
                      transition="fade-transition">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div class="d-flex flex-column flex-grow-1 pa-3 justify-space-between">
                    <div>
                      <div class="primary--text font-weight-bold text-subtitle-2 text-uppercase mb-1">
                        {{ device.shortForm || "KEINE KURZFORM" }}
                      </div>
                      <v-card-title class="pa-0 text-h6 font-weight-bold white--text" style="word-break: break-word; line-height: 1.2">
                        {{ device.title }}
                      </v-card-title>
                    </div>

                    <div class="text-subtitle-2 grey--text mt-2">
                      <v-icon small color="grey" class="mr-1">mdi-dumbbell</v-icon>
                      {{ device.activeExercises ? device.activeExercises.length : 0 }} Übungen
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <v-dialog v-model="deviceDialog" fullscreen hide-overlay transition="dialog-bottom-transition" dark>
      <DeviceDashboardForm v-if="deviceDialog" :deviceId="selectedDeviceId" @close="closeDeviceDialog" @saved="fetchDevices" />
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api"
import userService from "@/services/userService"
import { mapState, mapActions } from "vuex"
// Wir importieren das Formular direkt als Komponente!
import DeviceDashboardForm from "./deviceExerciseForm.vue"

export default {
  name: "deviceList",
  components: {
    DeviceDashboardForm,
  },
  data() {
    return {
      search: "",
      userService,
      activePanels: [],

      // Dialog State
      deviceDialog: false,
      selectedDeviceId: null,
    }
  },
  created() {
    this.fetchDevices()
  },
  computed: {
    ...mapState("deviceStore", ["deviceList"]),

    filteredDevices() {
      const searchTerm = (this.search || "").toLowerCase().trim()
      return this.deviceList.filter((device) => {
        if (device.deleted) return false
        device.activeExercises = device.exercises ? device.exercises.filter((e) => e && !e.deleted) : []
        if (!searchTerm) return true
        const titleMatch = device.title && device.title.toLowerCase().includes(searchTerm)
        const shortMatch = device.shortForm && device.shortForm.toLowerCase().includes(searchTerm)
        return titleMatch || shortMatch
      })
    },

    groupedCategories() {
      const groups = {}
      this.filteredDevices.forEach((device) => {
        const cat = device.category || "Ohne Kategorie"
        if (!groups[cat]) groups[cat] = []
        groups[cat].push(device)
      })
      return Object.keys(groups)
        .sort()
        .map((categoryName) => ({
          name: categoryName,
          devices: groups[categoryName],
        }))
    },
  },
  methods: {
    ...mapActions("deviceStore", ["setDeviceList", "resetDevice"]),

    async fetchDevices() {
      api.fetchDevices(null).then((deviceList) => {
        this.setDeviceList(JSON.parse(JSON.stringify(deviceList)))
        this.$nextTick(() => {
          this.activePanels = this.groupedCategories.map((_, i) => i)
        })
        this.$emit("finishedloading")
      })
    },

    // Dialog Methoden statt Router-Push!
    openDeviceDialog(device) {
      this.resetDevice()
      this.selectedDeviceId = device ? device._id : null
      this.deviceDialog = true
    },

    closeDeviceDialog() {
      this.deviceDialog = false
      this.selectedDeviceId = null
      this.fetchDevices()
    },
  },
}
</script>

<style scoped>
.deviceListWrapper {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
